<template>
    <div style="text-align: left">
        <p>
            在修改工艺单时，有两项可以修改，分别是<code>通知数量</code>，<code>标准工价</code>
        </p>

        <p>工艺单的 <code>通知数量</code>是根据上一步工艺的
            <code>上报数量</code>自动生成的，一般来说，你不需要修改工艺单，
            当然，也有特殊情况。
        </p>

        <p>
            <code>1.</code> 当前工艺是裁剪工艺，你必须自己分配通知数量
        </p>

        <p><code>2.</code>你收到的实际数量 与 通知数量 不符，<code>例如你只收到200件成品，但是通知包装的数量是 202 </code>，
            那你必须修改通知单的数量，这样才能按照实际数量下分任务。
        </p>

        <el-alert style="margin-top: 20px"
                  :closable="false"
                  title="一旦修改了通知数量，则必须填写备注"
                  type="warning"
                  show-icon>
        </el-alert>
        <el-divider></el-divider>
    </div>
</template>

<script>
    export default {
        name: "MdfCraft",
    }
</script>

<style scoped>

</style>